// Where each garment-cutting value came from (set by the fit engine + customer edits).
export const PROVENANCE_LABEL = {
  scan_plus_ease: 'Scan + Ease',
  scan: 'From Scan',
  customer_edited: 'Customer Edited',
  style_choice: 'Customer Choice',
  style_default: 'Recommended Default',
  fit_rule: 'Fit Rule',
  height_estimate: 'Estimated from Height',
  size_estimate: 'Size Estimate',
  photo_estimate: 'Photo Estimate',
  estimate: 'AI Estimated',
};

// Merge engine provenance with the customer's manual edits.
export const withEdits = (provenance = {}, edits = {}) => {
  const out = { ...provenance };
  Object.keys(edits).forEach(k => { out[k] = 'customer_edited'; });
  return out;
};
